import CrudCustom from '../../../libs/custom/CrudCustom';


let SandingAsetPerAsetService = new CrudCustom('/asets');
export default SandingAsetPerAsetService;
